/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CompanyApiRateLimitsResponse,
  DeleteCompanyApiRateLimitRequest,
  SetCompanyApiRateLimitRequest,
  SetCompanyApiRateLimitingEnabledRequest,
} from "../models/index";
import {
  CompanyApiRateLimitsResponseFromJSON,
  CompanyApiRateLimitsResponseToJSON,
  DeleteCompanyApiRateLimitRequestFromJSON,
  DeleteCompanyApiRateLimitRequestToJSON,
  SetCompanyApiRateLimitRequestFromJSON,
  SetCompanyApiRateLimitRequestToJSON,
  SetCompanyApiRateLimitingEnabledRequestFromJSON,
  SetCompanyApiRateLimitingEnabledRequestToJSON,
} from "../models/index";

export interface DeleteRequest {
  companyId: string;
  deleteCompanyApiRateLimitRequest: DeleteCompanyApiRateLimitRequest;
}

export interface ListRequest {
  companyId: string;
}

export interface SetRequest {
  companyId: string;
  setCompanyApiRateLimitRequest: SetCompanyApiRateLimitRequest;
}

export interface SetEnforcementRequest {
  companyId: string;
  setCompanyApiRateLimitingEnabledRequest: SetCompanyApiRateLimitingEnabledRequest;
}

/**
 *
 */
export class CompanyApiRateLimitsApi extends runtime.BaseAPI {
  /**
   * Clear an override so the company goes back to the coded default.
   * Clear an override so the company goes back to the coded default.
   */
  async _deleteRaw(
    requestParameters: DeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling _delete().',
      );
    }

    if (requestParameters["deleteCompanyApiRateLimitRequest"] == null) {
      throw new runtime.RequiredError(
        "deleteCompanyApiRateLimitRequest",
        'Required parameter "deleteCompanyApiRateLimitRequest" was null or undefined when calling _delete().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-api-rate-limits/delete`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteCompanyApiRateLimitRequestToJSON(
          requestParameters["deleteCompanyApiRateLimitRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Clear an override so the company goes back to the coded default.
   * Clear an override so the company goes back to the coded default.
   */
  async _delete(
    requestParameters: DeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this._deleteRaw(requestParameters, initOverrides);
  }

  /**
   * Every endpoint the public API serves, plus anything this company has an override on or has actually called. The full known set, not just the endpoints with a non-default limit: operations has to be able to raise a limit \\*before\\* a customer hits it, and the busiest endpoint we have (get-shipment) runs on the fallback default, so keying off the specific-defaults map alone would have made exactly the endpoint that matters uneditable. Usage is a trailing hour, so it cannot be the source of the list either --- an endpoint called yesterday would drop off and become uneditable again.
   * Every endpoint the public API serves, plus anything this company has an override on or has actually called.
   */
  async listRaw(
    requestParameters: ListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyApiRateLimitsResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling list().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-api-rate-limits/list`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyApiRateLimitsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Every endpoint the public API serves, plus anything this company has an override on or has actually called. The full known set, not just the endpoints with a non-default limit: operations has to be able to raise a limit \\*before\\* a customer hits it, and the busiest endpoint we have (get-shipment) runs on the fallback default, so keying off the specific-defaults map alone would have made exactly the endpoint that matters uneditable. Usage is a trailing hour, so it cannot be the source of the list either --- an endpoint called yesterday would drop off and become uneditable again.
   * Every endpoint the public API serves, plus anything this company has an override on or has actually called.
   */
  async list(
    requestParameters: ListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyApiRateLimitsResponse> {
    const response = await this.listRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async setRaw(
    requestParameters: SetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling set().',
      );
    }

    if (requestParameters["setCompanyApiRateLimitRequest"] == null) {
      throw new runtime.RequiredError(
        "setCompanyApiRateLimitRequest",
        'Required parameter "setCompanyApiRateLimitRequest" was null or undefined when calling set().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-api-rate-limits/set`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetCompanyApiRateLimitRequestToJSON(
          requestParameters["setCompanyApiRateLimitRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async set(
    requestParameters: SetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setRaw(requestParameters, initOverrides);
  }

  /**
   * Turn enforcement on or off for this company. Off is the default: counting, logging and alerting still run, so an operator can watch a company\'s real usage in the table above and size its limits before anything is refused.
   * Turn enforcement on or off for this company.
   */
  async setEnforcementRaw(
    requestParameters: SetEnforcementRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setEnforcement().',
      );
    }

    if (requestParameters["setCompanyApiRateLimitingEnabledRequest"] == null) {
      throw new runtime.RequiredError(
        "setCompanyApiRateLimitingEnabledRequest",
        'Required parameter "setCompanyApiRateLimitingEnabledRequest" was null or undefined when calling setEnforcement().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-api-rate-limits/set-enforcement`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetCompanyApiRateLimitingEnabledRequestToJSON(
          requestParameters["setCompanyApiRateLimitingEnabledRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Turn enforcement on or off for this company. Off is the default: counting, logging and alerting still run, so an operator can watch a company\'s real usage in the table above and size its limits before anything is refused.
   * Turn enforcement on or off for this company.
   */
  async setEnforcement(
    requestParameters: SetEnforcementRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setEnforcementRaw(requestParameters, initOverrides);
  }
}
